interface CandidateAvatarProps {
  name: string;
  imageUrl?: string | null;
}

const getInitials = (name: string): string =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

const CandidateAvatar = ({ name, imageUrl }: CandidateAvatarProps) =>
  imageUrl ? (
    <img
      src={imageUrl}
      alt={name}
      className="h-6 w-6 shrink-0 rounded-full object-cover"
    />
  ) : (
    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-200 text-[10px] font-semibold text-gray-600">
      {getInitials(name)}
    </span>
  );

export default CandidateAvatar;
